import axios from 'axios';
export default {
   getAll() {
       return axios.get(window.API_BASE + '/revenues');
   },

    search(params) {
        return axios.post(window.API_BASE + '/revenues/search', params);
    }
}